import { Injectable, Pipe, Directive, Renderer2, ElementRef, Input, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
class DoorgetsTruncateParser {
    constructor() {
        this.regexWord = /\s+/;
    }
    parse(sentence, options) {
        if (typeof sentence !== 'string') {
            throw new Error('Parameter "sentence" must be string');
        }
        const originOptions = {
            limit: 100,
            trail: '...',
            position: 'right',
            words: false
        };
        const _option = typeof options === 'object'
            ? Object.assign(originOptions, options)
            : originOptions;
        if (sentence.length < _option.limit && !_option.words) {
            return sentence;
        }
        const _words = sentence.split(' ');
        if (_words.length < _option.limit && _option.words) {
            return sentence;
        }
        const splitTag = _option.words
            ? this.regexWord
            : '';
        const joinTag = _option.words
            ? ' '
            : '';
        let prefix = '';
        let suffix = '';
        let isMiddleOption = _option.position === 'center';
        const keys = sentence.split(splitTag);
        if (keys.length > _option.limit) {
            if (isMiddleOption) {
                prefix = keys.slice(0, _option.limit % 2 == 0 ? _option.limit / 2 : _option.limit / 2 + 1).join(joinTag);
                suffix = keys.reverse().slice(0, _option.limit / 2).reverse().join(joinTag);
            }
            else {
                sentence = keys.slice(0, _option.limit).join(joinTag);
            }
        }
        switch (_option.position) {
            case 'left':
                return _option.trail + sentence;
            case 'center':
                return (prefix || suffix) ? prefix + _option.trail + suffix : sentence;
            default:
                return sentence + _option.trail;
        }
    }
}

let dgTruncateOptions = {
    limit: 100,
    trail: '...',
    position: 'right',
    words: false
};
let DgTruncateParser;
class DoorgetsTruncateService {
    constructor() {
        DgTruncateParser = DgTruncateParser || new DoorgetsTruncateParser();
        this._parser = DgTruncateParser;
    }
    truncate(sentence, options) {
        options = typeof options === 'object' ? options : {};
        const _options = Object.assign({}, dgTruncateOptions, options);
        return this._parser.parse(sentence, _options);
    }
    init(options) {
        if (typeof options === 'object') {
            dgTruncateOptions = Object.assign({}, dgTruncateOptions, options);
        }
    }
    getOptions() {
        return dgTruncateOptions;
    }
}
DoorgetsTruncateService.ɵfac = function DoorgetsTruncateService_Factory(t) { return new (t || DoorgetsTruncateService)(); };
DoorgetsTruncateService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DoorgetsTruncateService, factory: DoorgetsTruncateService.ɵfac });
DoorgetsTruncateService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DoorgetsTruncateService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class DoorgetsTruncatePipe {
    constructor(_service) {
        this._service = _service;
    }
    transform(sentence, options) {
        return this._service.truncate(sentence, options);
    }
}
DoorgetsTruncatePipe.ɵfac = function DoorgetsTruncatePipe_Factory(t) { return new (t || DoorgetsTruncatePipe)(ɵngcc0.ɵɵdirectiveInject(DoorgetsTruncateService, 16)); };
DoorgetsTruncatePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "dgTruncate", type: DoorgetsTruncatePipe, pure: true });
DoorgetsTruncatePipe.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DoorgetsTruncatePipe, factory: DoorgetsTruncatePipe.ɵfac });
DoorgetsTruncatePipe.ctorParameters = () => [
    { type: DoorgetsTruncateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DoorgetsTruncatePipe, [{
        type: Pipe,
        args: [{
                name: 'dgTruncate',
                pure: true
            }]
    }, {
        type: Injectable
    }], function () { return [{ type: DoorgetsTruncateService }]; }, null); })();

class DoorgetsTruncateDirective {
    constructor(_render, _element, _service) {
        this._render = _render;
        this._element = _element;
        this._service = _service;
        this.currentOptions = {};
    }
    set dgTruncate(sentence) {
        if (typeof sentence === 'string') {
            this.currentSentence = sentence;
            this.doTruncate();
        }
    }
    set dgTruncateOptions(options) {
        this.currentOptions = typeof options === 'object'
            ? options
            : {};
    }
    ngAfterViewChecked() {
        this.doTruncate();
    }
    doTruncate() {
        if (this.currentSentence) {
            this._element.nativeElement.textContent = ' ';
        }
        const childNodes = this._element.nativeElement.childNodes;
        for (let i = 0; i < childNodes.length; ++i) {
            const node = childNodes[i];
            if (node.nodeType === 3) {
                this.checkNode(node);
            }
        }
    }
    checkNode(node) {
        if (!this.currentSentence) {
            this.currentSentence = this.getContent(node.textContent.trim(), node);
        }
        this.transform(this.currentSentence, node);
    }
    getContent(content, node) {
        if (content.length > 0) {
            if (content !== node.currentValue) {
                this.currentSentence = content;
                node.content = node.textContent;
            }
            else if (node.content) {
                this.currentSentence = node.content.trim();
                node.lastSentence = null;
            }
        }
        return this.currentSentence;
    }
    transform(currentSentence, node) {
        const params = this.dgTruncateOptions;
        if (this.alreadyTransformed(node, currentSentence, params)) {
            return;
        }
        this.lastOptions = params;
        const truncated = this._service.truncate(currentSentence, this.currentOptions);
        this.updateContent(truncated, currentSentence, node);
    }
    setNodeKey(truncated, currentSentence, node) {
        if (truncated !== currentSentence) {
            node.lastSentence = currentSentence;
        }
    }
    setNodeContent(node) {
        if (!node.content) {
            node.content = node.textContent;
        }
    }
    updateContent(truncated, currentSentence, node) {
        this.setNodeKey(truncated, currentSentence, node);
        this.setNodeContent(node);
        node.currentValue = truncated
            ? truncated
            : (node.content || currentSentence);
        node.textContent = this.currentSentence
            ? node.currentValue
            : node.content.replace(currentSentence, node.currentValue);
    }
    alreadyTransformed(node, currentSentence, options) {
        return node.lastSentence === currentSentence && this.lastOptions === options;
    }
}
DoorgetsTruncateDirective.ɵfac = function DoorgetsTruncateDirective_Factory(t) { return new (t || DoorgetsTruncateDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DoorgetsTruncateService)); };
DoorgetsTruncateDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DoorgetsTruncateDirective, selectors: [["", "dgTruncate", ""]], inputs: { dgTruncate: "dgTruncate", dgTruncateOptions: "dgTruncateOptions" } });
DoorgetsTruncateDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: DoorgetsTruncateService }
];
DoorgetsTruncateDirective.propDecorators = {
    dgTruncate: [{ type: Input }],
    dgTruncateOptions: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DoorgetsTruncateDirective, [{
        type: Directive,
        args: [{
                selector: '[dgTruncate]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: DoorgetsTruncateService }]; }, { dgTruncate: [{
            type: Input
        }], dgTruncateOptions: [{
            type: Input
        }] }); })();

class DoorgetsTruncateModule {
}
DoorgetsTruncateModule.ɵfac = function DoorgetsTruncateModule_Factory(t) { return new (t || DoorgetsTruncateModule)(); };
DoorgetsTruncateModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DoorgetsTruncateModule });
DoorgetsTruncateModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [DoorgetsTruncateService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DoorgetsTruncateModule, [{
        type: NgModule,
        args: [{
                providers: [DoorgetsTruncateService],
                declarations: [DoorgetsTruncatePipe, DoorgetsTruncateDirective],
                exports: [DoorgetsTruncatePipe, DoorgetsTruncateDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DoorgetsTruncateModule, { declarations: [DoorgetsTruncatePipe, DoorgetsTruncateDirective], exports: [DoorgetsTruncatePipe, DoorgetsTruncateDirective] }); })();

/*
 * Public API Surface of doorgets-ng-truncate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DoorgetsTruncateDirective, DoorgetsTruncateModule, DoorgetsTruncateParser, DoorgetsTruncatePipe, DoorgetsTruncateService };

